import React from 'react';
import { Card, Table, Badge, Button } from '../ui';
import { Plus, Filter, Download, AlertCircle } from 'lucide-react';
export function ParticipantManagementView() {
  const participants = [{
    name: 'Royal Bank of Canada',
    id: 'P001',
    bic: 'ROYABSD1',
    connectivity: 'Online',
    status: 'Active'
  }, {
    name: 'Scotiabank Bahamas',
    id: 'P002',
    bic: 'NOSCBSD1',
    connectivity: 'Online',
    status: 'Active'
  }, {
    name: 'First Caribbean Int.',
    id: 'P003',
    bic: 'FCIBSD1',
    connectivity: 'Offline',
    status: 'Inactive'
  }, {
    name: 'Bank of The Bahamas',
    id: 'P004',
    bic: 'BOBBSD1',
    connectivity: 'Online',
    status: 'Pending'
  }, {
    name: 'Commonwealth Bank',
    id: 'P005',
    bic: 'COMBSD1',
    connectivity: 'Online',
    status: 'Active'
  }];
  return <div className="space-y-8" data-id="element-418">
      {/* Header Section */}
      <div className="flex justify-between items-start" data-id="element-419">
        <div data-id="element-420">
          <h2 className="text-3xl font-serif font-bold text-bank-navy" data-id="element-421">
            Participant Onboarding & Lifecycle
          </h2>
          <p className="text-lg text-slate-500 mt-2" data-id="element-422">
            Manage financial institutions, permissions, and account statuses.
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-423">
          <Button variant="outline" leftIcon={<Filter className="h-4 w-4" data-id="element-425" />} data-id="element-424">
            Filter
          </Button>
          <Button variant="outline" leftIcon={<Download className="h-4 w-4" data-id="element-427" />} data-id="element-426">
            Export
          </Button>
          <Button variant="primary" className="bg-bank-navy hover:bg-bank-navy-light" leftIcon={<Plus className="h-4 w-4" data-id="element-429" />} data-id="element-428">
            Add Participant
          </Button>
        </div>
      </div>

      {/* Maker-Checker Banner */}
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex justify-between items-center" data-id="element-430">
        <div className="flex items-start space-x-3" data-id="element-431">
          <AlertCircle className="h-5 w-5 text-amber-600 mt-0.5" data-id="element-432" />
          <div data-id="element-433">
            <p className="text-sm text-amber-900" data-id="element-434">
              Workflow Status: <span className="font-bold" data-id="element-435">PENDING</span>
            </p>
            <p className="text-xs text-amber-600 mt-0.5" data-id="element-436">
              Last updated: Today, 09:42 AM
            </p>
          </div>
        </div>
        <div className="text-right text-sm text-amber-900" data-id="element-437">
          <p data-id="element-438">
            <span className="font-bold" data-id="element-439">Maker:</span> Operator_A
          </p>
          <p data-id="element-440">
            <span className="font-bold" data-id="element-441">Checker:</span> Supervisor_B
          </p>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-442">
        <div className="px-6 py-5 border-b border-slate-100" data-id="element-443">
          <h3 className="text-xl font-serif font-bold text-bank-navy" data-id="element-444">
            Registered Institutions
          </h3>
          <p className="text-slate-500 mt-1" data-id="element-445">
            List of all participants connected to the FPS network.
          </p>
        </div>
        <Table data={participants} columns={[{
        header: 'INSTITUTION NAME',
        accessorKey: 'name' as const,
        className: 'font-medium text-slate-900 text-xs tracking-wider'
      }, {
        header: 'PARTICIPANT ID',
        accessorKey: 'id' as const,
        className: 'text-slate-600 text-xs tracking-wider'
      }, {
        header: 'BIC CODE',
        accessorKey: 'bic' as const,
        className: 'text-xs tracking-wider',
        cell: (item: any) => <span className="inline-block bg-slate-100 px-2 py-0.5 rounded text-xs font-mono text-slate-700 border border-slate-200" data-id="element-447">
                  {item.bic}
                </span>
      }, {
        header: 'CONNECTIVITY',
        accessorKey: 'connectivity' as const,
        className: 'text-xs tracking-wider',
        cell: (item: any) => <div className="flex items-center space-x-2" data-id="element-448">
                  <span className={`h-2 w-2 rounded-full ${item.connectivity === 'Online' ? 'bg-green-500' : 'bg-red-500'}`} data-id="element-449" />
                  <span className="text-sm text-slate-700" data-id="element-450">
                    {item.connectivity}
                  </span>
                </div>
      }, {
        header: 'STATUS',
        accessorKey: 'status' as const,
        className: 'text-xs tracking-wider',
        cell: (item: any) => <Badge variant={item.status === 'Active' ? 'success' : item.status === 'Inactive' ? 'error' : 'warning'} data-id="element-451">
                  {item.status}
                </Badge>
      }, {
        header: 'ACTIONS',
        className: 'text-xs tracking-wider',
        cell: () => <button className="text-sm font-medium text-bank-navy hover:underline focus:outline-none" data-id="element-452">
                  View
                </button>
      }]} data-id="element-446" />
      </div>
    </div>;
}